<app-header></app-header>


<mat-card>
  <mat-card-content>

    <div style="padding: 15px; text-align: center; font-size: 1.6em; font-weight: bold;">
      <img
        style="height: 40px; border-radius: 12px; border: 1px solid grey; vertical-align: middle; display: inline-block;"
        class="logo"
        src="assets/img/apps/king_app_icon.png"
        alt="king app icon"
      />
      <span style="margin-left: 15px; vertical-align: middle; display: inline-block;">king+</span>
    </div>




    <form *ngIf="accountDeletionForm" [formGroup]="accountDeletionForm" class="account-deletion">
      <mat-horizontal-stepper [linear]="true" #stepper>
        <mat-step formGroupName="token" [stepControl]="personalDataForm" [editable]="!accountDeletionForm.disabled">
          <ng-template matStepLabel>{{"ACCOUNT_DELETION.PERSONAL_DATA.LABEL" | translate}}</ng-template>
          <mat-card class="step-card">
            <mat-card-header>
              <mat-card-title>{{"ACCOUNT_DELETION.PERSONAL_DATA.TITLE" | translate}}</mat-card-title>
              <mat-card-subtitle>{{"ACCOUNT_DELETION.PERSONAL_DATA.SUBTITLE" | translate}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>

              <div style="margin-left: 15px;">

                <label style="margin-bottom: 3px;">{{"ACCOUNT_DELETION.PHONE.FORM.ENTER_PHONE" | translate}}</label><br />
                <div style="width: 200px;">
                  <mat-form-field>
                    <input matInput [placeholder]="'ACCOUNT_DELETION.PERSONAL_DATA.FORM.PHONE' | translate" formControlName="phone" [imask]="phoneMask" [unmask]="true" minlength="10"
                           maxlength="15" required>
                  </mat-form-field>
                </div>

                <div style="width: 200px;">
                  <app-date-edit  [placeholder]="'ACCOUNT_DELETION.PERSONAL_DATA.FORM.DOB' | translate" formControlName="dob" required
                                  [max]="maxDob" [min]="minDob"></app-date-edit>
                </div>
              </div>
            </mat-card-content>
            <mat-card-actions align="end">
              <div fxFlex></div>

              <button mat-raised-button color="primary" [disabled]="personalDataForm.invalid" type="button"
                      (click)="sendPhoneDob(personalDataForm.value)">{{"BUTTON.NEXT" | translate}}</button>
            </mat-card-actions>
          </mat-card>
        </mat-step>
        <mat-step formGroupName="sms" [stepControl]="smsForm" [editable]="!accountDeletionForm.disabled">
          <ng-template matStepLabel>{{"ACCOUNT_DELETION.PHONE.LABEL" | translate}}</ng-template>


          <div>
            <mat-card class="step-card" >
              <mat-card-header>
                <mat-card-title>{{"ACCOUNT_DELETION.PHONE.TITLE" | translate}}</mat-card-title>
                <mat-card-subtitle *ngIf="phone && (!smsSent || isSendingCode)"><div [innerHTML]="'ACCOUNT_DELETION.PHONE.SUBTITLE' | translate: {value: phone}"></div></mat-card-subtitle>
                <mat-card-subtitle *ngIf="phone && smsSent && !isSendingCode"><div [innerHTML]="'ACCOUNT_DELETION.PHONE.SUBTITLE_AFTER_SEND' | translate: {value: phone}"></div></mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>

                <div style="margin-left: 15px;">
                  <button [class.spinner]="isSendingCode" mat-raised-button type="button" color="primary" [disabled]="ticks > 0 || isSendingCode"
                          (click)="sendPhoneCode()">{{"ACCOUNT_DELETION.PHONE.FORM.SEND" | translate}} {{ getTick() }}</button>

                  <div style="margin-top: 10px">
                    {{"ACCOUNT_DELETION.PHONE.FORM.SEND_HINT" | translate}}
                  </div>

                  <mat-progress-bar *ngIf="isSendingCode" mode="indeterminate"></mat-progress-bar>

                  <div [hidden]="!smsSent || isSendingCode">
                    <mat-form-field>
                      <input matInput [placeholder]="'ACCOUNT_DELETION.PHONE.FORM.CODE' | translate" formControlName="code"
                             maxlength="6" pattern="[a-zA-Z0-9]*">
                    </mat-form-field>

                  </div>
                  <br />

                  <br />
                </div>
              </mat-card-content>
              <mat-card-actions align="end">
                <button mat-raised-button matStepperPrevious type="button">{{"BUTTON.PREVIOUS" | translate}}</button>
                <div fxFlex></div>

                <button mat-raised-button [disabled]="smsForm.invalid" color="primary" type="button"
                        (click)="verifyPhoneCode(smsForm.value)">{{"BUTTON.NEXT" | translate}}</button>
              </mat-card-actions>
            </mat-card>
          </div>

        </mat-step>

        <mat-step formGroupName="data" [stepControl]="dataForm" [editable]="!accountDeletionForm.disabled">

          <ng-template matStepLabel>{{"ACCOUNT_DELETION.CONFIRMATION.LABEL" | translate}}</ng-template>
          <mat-card class="step-card">
            <mat-card-header>
              <mat-card-title>{{"ACCOUNT_DELETION.CONFIRMATION.TITLE" | translate}}</mat-card-title>
              <mat-card-subtitle>{{"ACCOUNT_DELETION.CONFIRMATION.SUBTITLE" | translate}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>

              <div style="margin-left: 15px;">


                <ng-container *ngIf="!confirmed">
                  <p [innerHTML]="'ACCOUNT_DELETION.CONFIRMATION.DESCRIPTION' | translate: {}"></p>

                  <div style="margin-bottom: 20px;">

                    <mat-checkbox [disabled]="isConfirming" formControlName="deleteDataRequest">
                      <span [innerHTML]="'ACCOUNT_DELETION.CONFIRMATION.DELETE_DATA_ALSO' | translate: {}"></span>
                    </mat-checkbox>


                  </div>

                  <button mat-raised-button color="primary" [disabled]="isConfirming || notAllCardsClosed || unpaidInvoices" type="button"
                          (click)="sendConfirmation(dataForm.value)">{{"ACCOUNT_DELETION.CONFIRMATION.BUTTON_TEXT" | translate}}</button>


                </ng-container>

                <ng-container *ngIf="confirmed">
                  <p [innerHTML]="'ACCOUNT_DELETION.CONFIRMATION.DESCRIPTION_AFTER_CONFIRM' | translate: {firstName: firstName, requestId: requestId}"></p>
                </ng-container>


                <ng-container *ngIf="notAllCardsClosed">
                  <p [innerHTML]="'ACCOUNT_DELETION.CONFIRMATION.NOT_ALL_CARDS_CLOSED' | translate: {firstName: firstName, requestId: requestId}"></p>
                </ng-container>
                <ng-container *ngIf="unpaidInvoices">
                  <p [innerHTML]="'ACCOUNT_DELETION.CONFIRMATION.UNPAID_INVOICES' | translate: {firstName: firstName, requestId: requestId}"></p>
                </ng-container>



              </div>


            </mat-card-content>

          </mat-card>
        </mat-step>
      </mat-horizontal-stepper>
    </form>



  </mat-card-content>
</mat-card>


